import React from "react";
import CheckIcon from "./CheckIcon";

const ResultsTable = ({ results, onSelectAlternative }) => {
  const hasAlternatives = results.some((row) => row.origin?.alternatives?.length > 0 || row.destination?.alternatives?.length > 0);

  return (
    <div className="card mt-3">
      <div className="card-body">
        <table className="table table-striped my-3">
          <thead>
            <tr>
              <th>Grupo</th>
              <th>Rut</th>
              <th>Nombre</th>
              <th>Teléfono</th>
              <th>Fecha Programada</th>
              <th>Hora Programada</th>
              <th>Origen</th>
              <th>Destino</th>
              {hasAlternatives ? (
                <>
                  <th>Alternativas Origen</th>
                  <th>Alternativas Destino</th>
                </>
              ) : (
                <th>Estado</th>
              )}
            </tr>
          </thead>
          <tbody>
            {results.map((row, index) => (
              <tr key={index}>
                <td>{row.Grupo}</td>
                <td>{row.Rut}</td>
                <td>{row.Nombre}</td>
                <td>{row.Telefono}</td>
                <td>{row.FechaProgramado}</td>
                <td>{row.HoraProgramado}</td>
                <td>{row.Origen}</td>
                <td>{row.Destino}</td>
                {hasAlternatives ? (
                  <>
                    <td>
                      {row.origin?.alternatives?.length > 0 ? (
                        <ul>
                          {row.origin.alternatives.map((alt, i) => (
                            <li key={i}>
                              {alt.address}
                              <button className="btn btn-sm btn-primary ms-2" onClick={() => onSelectAlternative(alt.placeID, index, false)}>
                                Seleccionar
                              </button>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        "No se encontraron alternativas"
                      )}
                    </td>
                    <td>
                      {row.destination?.alternatives?.length > 0 ? (
                        <ul>
                          {row.destination.alternatives.map((alt, i) => (
                            <li key={i}>
                              {alt.address}
                              <button className="btn btn-sm btn-primary ms-2" onClick={() => onSelectAlternative(alt.placeID, index, true)}>
                                Seleccionar
                              </button>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        "No se encontraron alternativas"
                      )}
                    </td>
                  </>
                ) : (
                  <td className="text-center">
                    <CheckIcon />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ResultsTable;
